import React from 'react'
import "./HomePage.css"

function HomePage() {
  return (
    <div className="Container">
      <div className="Picture">
        <img className="pfp" src={require("../../imgs/sm_pfp.png")} alt="Kyle Pu in  NYC"/>
        <p className="EasterEgg">I Love Taking Pictures, But Not Selfies</p>
        <p className="EasterEgg">Selfie on a Balcony in NYC I Wish I Owned</p>
      </div>
      <div className="Caption">
        <p>CS, Bioinformatics @ UCLA Alum</p>
        <p>
          <a href="https://github.com/kyle-pu" target="_blank"><img className="IconLink" src={require("../../imgs/GitHub-Logo.png")} alt="GitHub Icon" /></a> {" "}

          <a href="https://linkedin.com/in/kyle-pu" target="_blank"><img className="IconLink" src={require("../../imgs/linkedin-logo-512x512.png")} alt="LinkedIn Icon" /></a> {" "}

          <a href="https://twitter.com/SciencePu" target="_blank"><img className="IconLink" src={require("../../imgs/Twitter social icons - circle - blue.png")} alt="Twitter Icon" /></a>{" "}

          <a href="https://scholar.google.com/citations?user=1nlDj9UAAAAJ&hl=en" target="_blank"><img className="IconLink" src={require("../../imgs/63222-google-scholar-doctor-science-university-philosophy-computer.png")} alt="Google Scholar Icon" /></a>{" "}

        </p>
      </div>
    </div>
  );
}

export default HomePage;
